import React from "react";
import { taskData } from "../Utils/CardsDashboardData";
import { useSelector } from "react-redux";
import { selectData } from "../../redux/features/userSliceWithTokenValidation";
import CardStat from "../Utils/charts/CardDataStats"
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { format, startOfWeek, addDays } from "date-fns";
import fr from "date-fns/locale/fr";
import { useGetDataByIdQuery } from "../../services/auth-services/AuthService";
import { ProjectsEndpoints } from "../../Routes/api/Endpoints";

const DashboardPageActor = () => {
  const user = useSelector(selectData);
  const { data: projets, refetch } = useGetDataByIdQuery({
    endpoint: user?.statut === "coach" || user?.statut === "coach-assistant" ? ProjectsEndpoints.nombreProjetCoach : ProjectsEndpoints.nombreProjetParticipant,
      id: user?.id
    }, {refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      skip: false });
  const { data: livrables } = useGetDataByIdQuery({
    endpoint: user?.statut === "coach" || user?.statut === "coach-assistant" ? ProjectsEndpoints.nombreLivrableCoach : ProjectsEndpoints.nombreLivrableBakeliste,
      id: user?.id
    }, {refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      skip: false });

  const stats = [
    {
      title: "Nombre de projets",
      value: projets?.nombre_projets,
      icon: <svg xmlns="http://www.w3.org/2000/svg" className="text-orange" width="50" height="50" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m9.5 14.5l-6-2.5V4l6-2.5zm-6.885-1.244A1 1 0 0 1 2 12.333V3.667a1 1 0 0 1 .615-.923L8.923.115A1.5 1.5 0 0 1 11 1.5V2h1.25c.966 0 1.75.783 1.75 1.75v8.5A1.75 1.75 0 0 1 12.25 14H11v.5a1.5 1.5 0 0 1-2.077 1.385zM11 12.5h1.25a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H11z" clip-rule="evenodd" /></svg>,
      color: "text-blue-500",
    },
    {
      title: "Nombre de tâches",
      value: projets?.nombre_taches,
      icon: <svg xmlns="http://www.w3.org/2000/svg" className="text-green-500" width="50" height="50" viewBox="0 0 512 512"><path fill="currentColor" d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72l-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69l72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96m432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16m0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16m0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16" /></svg>,
      color: "text-green-500",
    },
    {
      title: "Nombre de livrables",
      value: livrables?.total_livraisons,
      icon: <svg xmlns="http://www.w3.org/2000/svg" className="text-orange-500" width="50" height="50" viewBox="0 0 32 32"><path fill="currentColor" d="m29.482 8.624l-10-5.5a1 1 0 0 0-.964 0l-10 5.5a1 1 0 0 0 0 1.752L18 15.591V26.31l-3.036-1.67L14 26.391l4.518 2.485a1 1 0 0 0 .964 0l10-5.5A1 1 0 0 0 30 22.5v-13a1 1 0 0 0-.518-.876M19 5.142L26.925 9.5L19 13.858L11.075 9.5Zm9 16.767l-8 4.4V15.59l8-4.4Z" /><path fill="currentColor" d="M10 16H2v-2h8zm2 8H4v-2h8zm2-4H6v-2h8z" /></svg>,
      color: "text-orange-500",
    },
    {
      title: "Nombre de Bakelistes",
      value: projets?.nombre_participants,
      icon: <svg xmlns="http://www.w3.org/2000/svg" className="text-blue-500" width="50" height="50" viewBox="0 0 24 24"><path fill="currentColor" d="M24 14.6c0 .6-1.2 1-2.6 1.2c-.9-1.7-2.7-3-4.8-3.9c.2-.3.4-.5.6-.8h.8c3.1-.1 6 1.8 6 3.5M6.8 11H6c-3.1 0-6 1.9-6 3.6c0 .6 1.2 1 2.6 1.2c.9-1.7 2.7-3 4.8-3.9zm5.2 1c2.2 0 4-1.8 4-4s-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4m0 1c-4.1 0-8 2.6-8 5c0 2 8 2 8 2s8 0 8-2c0-2.4-3.9-5-8-5m5.7-3h.3c1.7 0 3-1.3 3-3s-1.3-3-3-3c-.5 0-.9.1-1.3.3c.8 1 1.3 2.3 1.3 3.7c0 .7-.1 1.4-.3 2M6 10h.3C6.1 9.4 6 8.7 6 8c0-1.4.5-2.7 1.3-3.7C6.9 4.1 6.5 4 6 4C4.3 4 3 5.3 3 7s1.3 3 3 3" /></svg>,
      color: "text-purple-500",
      bakeliste: true
    },
  ];
  
  const { data: statsHebdo } = useGetDataByIdQuery({
    endpoint: user?.statut === "coach" || user?.statut === "coach-assistant" ? ProjectsEndpoints.statsHebdomadaires : ProjectsEndpoints.statsHebdomadairesBakeliste,
    id: user?.id
  }, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    skip: false
  });  


  // Remplacer la génération des données du graphique par :
  const graphData = statsHebdo ? Object.entries(statsHebdo.stats_hebdomadaires).map(([periode, stats]) => {
    return {
      periode: periode,
      aFaire: stats.A_FAIRE,
      enCours: stats.EN_COURS,
      terminee: stats.TERMINEE,
      enRevue: stats.EN_REVUE,
      acceptee: stats.ACCEPTEE
    };
  }) : [];

  return (
    <div className=" pb-4">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-3">
          <span className="border-e-2 border-grys/50 pe-2 text-blur">
            Dashboard
          </span>
          <span className="flex gap-2 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.2em"
              height="1.2em"
              viewBox="0 0 1024 1024"
            >
              <path
                fill="currentColor"
                d="M448 68.48v64.832A384.128 384.128 0 0 0 512 896a384.13 384.13 0 0 0 378.688-320h64.768A448.128 448.128 0 0 1 64 512A448.13 448.13 0 0 1 448 68.48"
              ></path>
              <path
                fill="currentColor"
                d="M576 97.28V448h350.72A384.064 384.064 0 0 0 576 97.28M512 64V33.152A448 448 0 0 1 990.848 512H512z"
              ></path>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
            >
              <g fill="none" fillRule="evenodd">
                <path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path>
                <path
                  fill="currentColor"
                  d="M15.707 11.293a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 1 1-1.414-1.414l4.95-4.95l-4.95-4.95a1 1 0 0 1 1.414-1.414z"
                ></path>
              </g>
            </svg>
          </span>
          <span  className='font-mandali font-normal text-sm text-black'>Dashboard</span>
        </div>
        <div className="inline-flex gap-1 text-[13px] text-blueclear font-mandali">
          <span>Bonjour,</span>
          <span>
            {(user?.statut === "coach" || user?.statut === "coach-assistant") && "coach"} {user?.name}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-4 max-lg:grid-cols-2 max-md:grid-cols-1 gap-4 mt-4">
        {user?.statut === "coach" ? stats?.map((stat, index) => (
          <CardStat key={index} {...stat} />
        )) : stats?.filter(stat => !stat.bakeliste).map((stat, index) => (
          <CardStat key={index} {...stat} />
        ))}
      </div>


      <div className="bg-white shadow-md rounded-lg p-4 mt-6">
        <h3 className="text-lg font-semibold mb-3 text-gray-700">Évolution des Tâches (Semaine Actuelle)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={graphData}>
            <XAxis
              dataKey="periode"
              stroke="#8884d8"
              // angle={-45} 
              textAnchor="end"
              height={60} 
            />
            <YAxis />
            <Tooltip />
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />

            {/* Courbes pour chaque état des tâches */}
            <Line type="monotone" dataKey="aFaire" stroke="#FF5733" strokeWidth={2} name="À Faire" />
            <Line type="monotone" dataKey="enCours" stroke="#3498db" strokeWidth={2} name="En Cours" />
            <Line type="monotone" dataKey="terminee" stroke="#2ecc71" strokeWidth={2} name="Terminée" />
            <Line type="monotone" dataKey="enRevue" stroke="#f39c12" strokeWidth={2} name="En Revue" />
            <Line type="monotone" dataKey="acceptee" stroke="#9b59b6" strokeWidth={2} name="Acceptée" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DashboardPageActor;
